import {QuoteWizardStateService} from '../../quoteWizardState.service';
import {QuoteWizardNavigationService} from '../../quoteWizardNavigation.service';
import {ISession} from '../../../core/services/sessionService/session.service';

export class QuoteWizardDefaultCustomViewController {
    public subject: any;
    public quoteWizardForm: ng.IFormController;

    public static $inject = ['$stateParams', 'quoteWizardNavigationService', 'quoteWizardStateService', 'ValidationService', 'sessionService'];

    constructor(public parameters: any,
                public navigationService: QuoteWizardNavigationService,
                public stateService: QuoteWizardStateService,
                public validationService: any,
                public sessionService: ISession
    ) {
        this.activate();
    }

    protected activate(): void {
        this.validationService = new this.validationService();
        this.validationService.setGlobalOptions({controllerAs: this, debounce: 1, hideErrorUnderInputs: true});
        if (this.parameters && this.parameters.wizardParams) {
            this.subject = this.parameters.wizardParams.subject;
        }
    }

    public goNext(): void {
        if (this.quoteWizardForm && this.validationService.checkFormValidity(this.quoteWizardForm) === false) {
            return;
        }
        this.navigationService.goNext();
    }

    public goBack(): void {
        this.navigationService.goBack();
    }
}